var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStrawberry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8014 10L24.7014 5.70001L19.4014 7.59998L16.3014 3L13.1014 7.59998L7.90137 5.70001L9.80136 10",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2017 16.4004V17.8004",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1016 15.2002V16.7002",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3018 15.2002V16.7002",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8013 20.4004V21.9004",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5015 20.4004V21.9004",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9015 28.4C14.1923 28.7557 14.5584 29.0422 14.9735 29.239C15.3885 29.4358 15.8422 29.5378 16.3015 29.5378C16.7609 29.5378 17.2145 29.4358 17.6295 29.239C18.0446 29.0422 18.4108 28.7557 18.7015 28.4L24.5015 21.8C25.849 20.2447 26.5941 18.2578 26.6015 16.2C26.6148 15.3989 26.4701 14.6031 26.1757 13.8579C25.8813 13.1128 25.443 12.4329 24.8858 11.8571C24.3287 11.2814 23.6635 10.821 22.9284 10.5024C22.1933 10.1837 21.4026 10.013 20.6015 10H12.0015C11.2004 10.013 10.4097 10.1837 9.67462 10.5024C8.93951 10.821 8.27439 11.2814 7.71722 11.8571C7.16005 12.4329 6.72174 13.1128 6.42736 13.8579C6.13298 14.6031 5.98828 15.3989 6.00152 16.2C5.96151 18.2662 6.71278 20.2696 8.10153 21.8L13.9015 28.4Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrawberry);
export default __webpack_public_path__ + "static/media/strawberry.2c90efe9c5eb4bad3cee17779919720a.svg";
export { ForwardRef as ReactComponent };